import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import NewsDetails from '../Pages/NewsDetails'


function NewsDetailsLayout() {
  return (
   <>
   <Header />
    <NewsDetails />
   <Footer />
   </>
  )
  
}

export default NewsDetailsLayout